import type { SiteName } from '@/scopes/common/domain/types'

const SPLASH_PAGE_URLS: Partial<Record<SiteName, string>> = {
  sunwebbenl: '/nl',
  sunwebbefr: '/fr',
}

export function getSplashPageUrl(siteName: SiteName): string {
  return SPLASH_PAGE_URLS[siteName] ?? '/'
}
